import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-comment\"><path d=\"M1024 448v384a96 96 0 0 1-96 96H384a96.032 96.032 0 0 1-90.56-64H211.52l-98.944 115.296A64 64 0 0 1 0 937.6V160a96 96 0 0 1 96-96h768a96 96 0 0 1 96 96v197.44c37.28 13.216 64 48.768 64 90.56z m-512 96h288a32 32 0 0 1 0 64h-288a32 32 0 0 1 0-64z m0 128h192a32 32 0 0 1 0 64h-192a32 32 0 0 1 0-64z m-128-256a32 32 0 0 0-32 32v384a32 32 0 0 0 32 32h544a32 32 0 0 0 32-32V448a32 32 0 0 0-32-32H384z m512-64V160a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v777.6l108.544-126.432A32 32 0 0 1 196.832 800H288V448a96 96 0 0 1 96-96h512z\" fill=\"#8a8a8a\" p-id=\"5157\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/comment.svg
// module id = SdtW
// module chunks = 38